import Box from '@mui/material/Box'
import { EmtTypography } from 'emt-components-v2'
import InlinePet from '@/components/EMT/InlinePet'
import NextALink from '@/components/NextALink'
import { Routes } from '@/assets/configs'
import React from 'react'
import { UserCardAnimal } from '@/dataV3/Search/UserCard'
import { BoxProps } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { useIsQueryOwner, useIsResponsive } from '@/hooks'
import useFloatingProfile, { ProfileKind } from '@/hooks/useFloatingProfile'

interface Props extends BoxProps {
  pets: UserCardAnimal[]
  onMobileClickCard?: ReturnType<typeof useFloatingProfile>['handleOpenProfile']
}

const PetsSubView: React.FC<Props> = ({ pets, onMobileClickCard, ...props }) => {
  const { t } = useTranslation('message')
  const [, , appendQueryType] = useIsQueryOwner(true)
  const [isMobile] = useIsResponsive()

  return (
    <Box {...props} sx={{ px: 2, ...props?.sx }}>
      <EmtTypography variant="body1" fontWeight="700" sx={{ mb: 1 }}>
        {t('messages.animals')}
      </EmtTypography>
      {pets.map((pet) => {
        const node = <InlinePet pet={pet} sx={{ padding: '10px' }} />

        return isMobile ? (
          <Box
            component={'span'}
            sx={{ cursor: 'pointer', textDecoration: 'none' }}
            onClick={onMobileClickCard ? () => onMobileClickCard(pet.id, ProfileKind.Community) : undefined}
          >
            {node}
          </Box>
        ) : (
          <Box sx={{ '& a': { textDecoration: 'none!important' } }}>
            <NextALink href={appendQueryType(Routes.Profile(pet.id))}>{node}</NextALink>
          </Box>
        )
      })}
    </Box>
  )
}

export default PetsSubView
